import {create} from 'zustand';

interface QueueState {
  /** Number of pending mutations in the queue */
  pendingCount: number;
  /** Number of failed mutations in the queue */
  failedCount: number;
  /** Whether the replay engine is currently processing the queue */
  isReplaying: boolean;

  setPendingCount: (count: number) => void;
  setFailedCount: (count: number) => void;
  setIsReplaying: (replaying: boolean) => void;
}

const initialState = {
  pendingCount: 0,
  failedCount: 0,
  isReplaying: false,
};

export const useQueueStore = create<QueueState>((set) => ({
  ...initialState,

  setPendingCount: (count) => set({pendingCount: count}),
  setFailedCount: (count) => set({failedCount: count}),
  setIsReplaying: (replaying) => set({isReplaying: replaying}),
}));

export function resetQueueStore() {
  useQueueStore.setState(initialState);
}
